/**
 * @file hooks/biz/confirm 弹框hooks
 * @author zhangyibo02
 */

import React, {useState, useCallback, useMemo} from 'react';
import {DialogBox} from 'acud';

export type CONFIRM_TYPE = 'warning' | 'success' | 'info' | 'error';

export interface ConfirmOption {
    type: CONFIRM_TYPE;
    title: string;
    content: string;
    visible?: boolean;
    footer: React.ReactNode;
    okText?: string;
    cancelText?: string;
    maskClosable?: boolean;
    mask?: boolean;
    onOk: () => void;
    onCancel: () => void;
}

const useConfirm: any = () => {
    const [confirmOptions, setConfirmOptions]: [ConfirmOption | undefined, any] = useState(undefined);

    const handleConfirmCancel = useCallback(() => {
        setConfirmOptions(undefined);
    }, [setConfirmOptions]);

    const handleConfirmOk = useCallback(onOk => {
        onOk && onOk();
        setConfirmOptions(undefined);
    }, []);

    const Confirm = useMemo(() => {
        if (confirmOptions) {
            const {onOk} = confirmOptions;
            return (
                <DialogBox
                    {...confirmOptions}
                    visible
                    onOk={() => handleConfirmOk(onOk)}
                    onCancel={handleConfirmCancel}
                />
            );
        }
        return null;
    }, [handleConfirmOk, handleConfirmCancel, confirmOptions]);

    return {
        Confirm,
        confirmOptions,
        setConfirmOptions,
        handleConfirmCancel
    };
};

export default useConfirm;
